const filterUsers = (filter, items) => {
  return items.filter(item => isUserMatchesFilter(item, filter))
}

function isUserMatchesFilter(user, filter) {
  const keys = Object.keys(filter)
    .filter(key => key in user)
    .map(key => key)

  return keys.every(key => {
    const filterValue = filter[key]
    if (filterValue === undefined) return true

    const userValue = user[key]
    const filterValueUpper = filterValue.toUpperCase()

    if (key === "company") {
      if (filterValueUpper.toUpperCase() === "UNASSIGNED") {
        return userValue === undefined || userValue === null
      }

      if (userValue === undefined || userValue === null) return false
      if (typeof userValue !== "object" || !("name" in userValue)) return false
      return userValue.name.toUpperCase().includes(filterValueUpper)
    }

    if (typeof userValue === "boolean") {
      return (
        (filterValueUpper === "TRUE" && userValue) ||
        (filterValueUpper === "FALSE" && !userValue)
      )
    }

    if (typeof userValue === "string") {
      const userValueUpper = userValue.toUpperCase()
      if (key === "role") {
        return userValueUpper === filterValueUpper
      }

      return userValueUpper.includes(filterValueUpper)
    }

    throw new Error(`Unhandled filter key: ${key}`)
  })
}

export default filterUsers
